<template>
  <div class="videoList">
    <div
      class="imgArea"
      v-show="!videoList || !videoList.length || !isPlayVideo"
    >
      <el-image
        :fit="'contain'"
        class="bannerImg"
        :src="dataSource.detailBgImgUrl || defImg"
        alt="banner"
      />
      <el-image
        v-if="dataSource.logoFileUrl"
        :fit="'contain'"
        class="logo"
        :src="dataSource.logoFileUrl"
        alt="banner"
      />
      <img
        v-if="videoList && videoList.length"
        @click="onPlay"
        src="~@/assets/img/preferredBrand/play_icon.svg"
        class="playIcon"
      />
    </div>
    <div class="video-container" v-show="isPlayVideo">
      <video
        width="100%"
        id="topVideoEl"
        controls
        oncontextmenu="return false"
        controlsList="nodownload"
        :autoplay="false"
        preload="auto"
        :src="videoUrl"
      ></video>
    </div>
    <div class="btnArea" v-if="isPlayVideo">
      <div class="btns">
        <div
          class="btn"
          v-for="(item, index) in videoList"
          :key="item.fileUrl"
          :class="{ 'active-btn': videoIndex === index }"
          @click="setVideoIndex(index)"
        >
          {{ item.fileName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoList: {
      type: Array,
      default: () => [],
    },
    dataSource: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    videoUrl() {
      console.log(this.videoList);

      return this.videoList && this.videoList.length
        ? this.videoList[this.videoIndex].fileUrl || ""
        : "";
    },
  },
  data() {
    return {
      videoIndex: 0,
      isPlayVideo: false,
      defImg:
        "https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/preferredBrand/preferredClassify_info_top_bg_2.png",
    };
  },
  methods: {
    onPlay() {
      this.isPlayVideo = true;
      const dom = document.getElementById("topVideoEl");
      if (dom) {
        dom.play();
      }
    },
    onStop() {
      this.isPlayVideo = false;
    },
    setVideoIndex(index) {
      this.videoIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.videoList {
  font-family: Alibaba PuHuiTi;
  .imgArea {
    position: relative;
  }
  .bannerImg {
    width: 100%;
    object-fit: contain;
  }
  .logo {
    position: absolute;
    top: 44px;
    left: calc((100vw - 1200px) / 2);
    height: 80px;
    object-fit: contain;
  }
  .playIcon {
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btnArea {
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #f2f2f4;
    margin-top: 24px;
    .btns {
      border-radius: 16px;
      background: #a8a8a8;
      padding: 2px;
      display: flex;
    }
    .btn {
      padding: 8px 16px;
      cursor: pointer;
    }
    .active-btn {
      border-radius: 14px;
      background: #ffffff;
      font-weight: bold;
      color: #2a54d1;
    }
  }
  .video-container {
    position: relative;
    padding-top: 56.25%; /* 16:9 比例 (9 ÷ 16 = 0.5625) */
    height: 0;
    overflow: hidden;
    background: #000;
  }

  .video-container video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
  }
}
</style>
